import { render, staticRenderFns } from "./product-tile.vue?vue&type=template&id=02f548a6&"
import script from "./product-tile.vue?vue&type=script&lang=js&"
export * from "./product-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports